<div
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="100"
  [attr.aria-valuenow]="clamp(progress, 0, 100) | number:'1.0-2'"
  [attr.aria-valuetext]="(clamp(progress, 0, 100) | number:'1.0-2') + ' ' + (progressText)"
  class="container"
  role="progressbar"
  [opacTooltip]="(clamp(progress, 0, 100) | number:'1.0-2') + ' ' + (progressText)"
>
  <div class="progress-track"></div>
  <div class="progress" [style.width.%]="progress"></div>
</div>
